import React from 'react';
import { Skeleton } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

const ROW_COUNT = 8;

/**
 * Loading placeholder for the **account tree only**.
 *
 * Per the repo's loading-state standard a skeleton stands in for dynamic
 * content alone: the toolbar around this grid (search, show-archived switch,
 * account count, "Add account") keeps its real labels and is disabled while the
 * chart loads, so the page never greys out its own chrome.
 */
export const ChartOfAccountsSkeleton: React.FC = () => {
    return (
        <div {...getNodeTestIdProp('chart-of-accounts-skeleton')}>
            <div className="flex items-center gap-4 border-b border-separator px-4 py-3">
                <Skeleton className="h-3 w-40 rounded" />
                <Skeleton className="ml-auto h-3 w-16 rounded" />
                <Skeleton className="h-3 w-16 rounded" />
                <Skeleton className="h-3 w-24 rounded" />
            </div>
            {Array.from({ length: ROW_COUNT }).map((_, index) => (
                <div
                    className="flex items-center gap-4 px-4 py-3"
                    // Static placeholder rows — index key is safe here.
                    key={`chart-of-accounts-skeleton-row-${index}`}
                    style={{ paddingInlineStart: 16 + (index % 3) * 22 }}
                >
                    <Skeleton className="size-6 shrink-0 rounded" />
                    <Skeleton className="h-4 w-48 rounded" />
                    <Skeleton className="ml-auto h-4 w-14 rounded" />
                    <Skeleton className="h-5 w-16 rounded-full" />
                    <Skeleton className="h-4 w-24 rounded" />
                </div>
            ))}
        </div>
    );
};
